import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetSpaceCapacityWindowMutationVariables = Types.Exact<{
  input: Types.SetSpaceCapacityWindowInput;
}>;


export type SetSpaceCapacityWindowMutation = { __typename?: 'Mutation', setSpaceCapacityWindow: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReplaceSpaceCapacityWindowMutationVariables = Types.Exact<{
  input: Types.ReplaceSpaceCapacityWindowInput;
}>;


export type ReplaceSpaceCapacityWindowMutation = { __typename?: 'Mutation', replaceSpaceCapacityWindow: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveSpaceCapacityWindowMutationVariables = Types.Exact<{
  input: Types.RemoveSpaceCapacityWindowInput;
}>;


export type RemoveSpaceCapacityWindowMutation = { __typename?: 'Mutation', removeSpaceCapacityWindow: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetSpaceTypeCapacityMutationVariables = Types.Exact<{
  input: Types.SetSpaceTypeCapacityInput;
}>;


export type SetSpaceTypeCapacityMutation = { __typename?: 'Mutation', setSpaceTypeCapacity: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveSpaceTypeCapacityMutationVariables = Types.Exact<{
  input: Types.RemoveSpaceTypeCapacityInput;
}>;


export type RemoveSpaceTypeCapacityMutation = { __typename?: 'Mutation', removeSpaceTypeCapacity: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetSpaceCapacityWindowDocument = new TypedDocumentString(`
    mutation SetSpaceCapacityWindow($input: SetSpaceCapacityWindowInput!) {
  setSpaceCapacityWindow(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const ReplaceSpaceCapacityWindowDocument = new TypedDocumentString(`
    mutation ReplaceSpaceCapacityWindow($input: ReplaceSpaceCapacityWindowInput!) {
  replaceSpaceCapacityWindow(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const RemoveSpaceCapacityWindowDocument = new TypedDocumentString(`
    mutation RemoveSpaceCapacityWindow($input: RemoveSpaceCapacityWindowInput!) {
  removeSpaceCapacityWindow(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const SetSpaceTypeCapacityDocument = new TypedDocumentString(`
    mutation SetSpaceTypeCapacity($input: SetSpaceTypeCapacityInput!) {
  setSpaceTypeCapacity(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const RemoveSpaceTypeCapacityDocument = new TypedDocumentString(`
    mutation RemoveSpaceTypeCapacity($input: RemoveSpaceTypeCapacityInput!) {
  removeSpaceTypeCapacity(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetSpaceCapacityWindow: build.mutation<SetSpaceCapacityWindowMutation, SetSpaceCapacityWindowMutationVariables>({
      query: (variables) => ({ document: SetSpaceCapacityWindowDocument, variables })
    }),
    ReplaceSpaceCapacityWindow: build.mutation<ReplaceSpaceCapacityWindowMutation, ReplaceSpaceCapacityWindowMutationVariables>({
      query: (variables) => ({ document: ReplaceSpaceCapacityWindowDocument, variables })
    }),
    RemoveSpaceCapacityWindow: build.mutation<RemoveSpaceCapacityWindowMutation, RemoveSpaceCapacityWindowMutationVariables>({
      query: (variables) => ({ document: RemoveSpaceCapacityWindowDocument, variables })
    }),
    SetSpaceTypeCapacity: build.mutation<SetSpaceTypeCapacityMutation, SetSpaceTypeCapacityMutationVariables>({
      query: (variables) => ({ document: SetSpaceTypeCapacityDocument, variables })
    }),
    RemoveSpaceTypeCapacity: build.mutation<RemoveSpaceTypeCapacityMutation, RemoveSpaceTypeCapacityMutationVariables>({
      query: (variables) => ({ document: RemoveSpaceTypeCapacityDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetSpaceCapacityWindowMutation, useReplaceSpaceCapacityWindowMutation, useRemoveSpaceCapacityWindowMutation, useSetSpaceTypeCapacityMutation, useRemoveSpaceTypeCapacityMutation } = injectedRtkApi;
